
export default {
    namespaced: true,
    state: {
        flagPeticiones: false,
        flagPermutaActiva: true,
        flagMiPermuta: null,
    },
    getters: {

    },
    mutations: {
        setFlagPeticiones(state, flag) {
            state.flagPeticiones = flag;
        },
        setFlagPermutaActiva(state, flag) {            
            state.flagPermutaActiva = flag;
        },
        setFlagMiPermuta(state, flag) {
            state.flagMiPermuta = flag;
        }


    },
    actions: {

    },
};


